import { faFileLines } from '@fortawesome/free-solid-svg-icons';
import { createStackNavigator } from '@react-navigation/stack';
import { DocumentsSchemas } from '../schemas/documents';
import { DocumentsParamList } from '../typings/Params';
import { Module } from '../Routes';
import DocumentCategories from '../pages/documents/DocumentCategories/DocumentCategories';
import Documents from '../pages/documents/Documents/Documents';
import TermsAndPrivacyGuardianApp from '../pages/documents/TermsAndPrivacyGuardianApp/TermsAndPrivacyGuardianApp';
import TermsAndPrivacyCitizenApp from '../pages/documents/TermsAndPrivacyCitizenApp/TermsAndPrivacyCitizenApp';
import TermsAndPrivacyGuardianForm from '../pages/documents/TermsAndPrivacyGuardianApp/TermsAndPrivacyGuardianForm';
import TermsAndPrivacyPlatformApp from '../pages/documents/TermsAndPrivacyPlatform/TermsAndPrivacyPlatformApp';
import TermsAndPrivacyPlatformForm from '../pages/documents/TermsAndPrivacyPlatform/TermsAndPrivacyPlatformForm';
import TermsAndPrivacyCitizenForm from '../pages/documents/TermsAndPrivacyCitizenApp/TermsAndPrivacyCitizenForm';

export const documentsModule: Module<'Documents'> = {
    path: '/documents',
    stackNavigator: createStackNavigator<DocumentsParamList>(),
    canAccess: (user, currentApp) => Boolean(user && !currentApp.isAgentApp),
    icon: require('../../assets/icon_documents.png'),
    logo: require('../../assets/logo_documents.png'),
    label: 'documents',
    navigate: (navigation) => navigation.navigate('Documents'),
    schemas: DocumentsSchemas,
    screens: {
        DocumentsList: {
            path: 'documents-list',
            selectedItem: 'documents',
            component: Documents,
            label: 'documents',
            canAccess: (user) =>
                Boolean(
                    user?.permissions.documents_module_access
                    || user?.permissions.documents_manage_documents
                    || user?.permissions.documents_manage_all_acting_bodies_documents
                    || user?.permissions.documents_manage_acting_body_units_documents),
            accessInformation: {
                icon: faFileLines,
                navigate: (navigation) => navigation.navigate('Documents', { screen: 'DocumentsList' }),
            },
            initialParams: () => ({
                limit: 25,
                page: 1,
            }),
        },
        DocumentCategories: {
            path: 'document-categories',
            selectedItem: 'document-categories',
            component: DocumentCategories,
            label: 'documentCategories',
            canAccess: (user) =>
                Boolean(user?.permissions.documents_module_access
                    || user?.permissions.documents_manage_document_category
                    || user?.permissions.documents_manage_acting_body_units_document_category
                    || user?.permissions.documents_manage_all_acting_bodies_document_category),
            accessInformation: {
                icon: faFileLines,
                navigate: (navigation) => navigation.navigate('Documents', { screen: 'DocumentCategories' }),
            },
            initialParams: () => ({
                limit: 25,
                page: 1,
            }),
        },
        TermsAndPrivacyPlatformApp: {
            path: 'terms-and-privacy-platform-app',
            selectedItem: 'terms-and-privacy-platform-app',
            component: TermsAndPrivacyPlatformApp,
            label: 'TermsAndPrivacyPlatformApp',
            canAccess: (user) =>
                Boolean(user?.permissions.documents_manage_terms_of_use_and_privacy
                    || user?.permissions.documents_manage_platform_terms_of_use_and_privacy),
            accessInformation: {
                icon: faFileLines,
                navigate: (navigation) => navigation.navigate('Documents', { screen: 'TermsAndPrivacyPlatformApp' }),
            },
            initialParams: () => ({
                limit: 25,
                page: 1,
            }),
        },
        TermsAndPrivacyGuardianApp: {
            path: 'terms-and-privacy-guardian-app',
            selectedItem: 'terms-and-privacy-guardian-app',
            component: TermsAndPrivacyGuardianApp,
            label: 'TermsAndPrivacyGuardianApp',
            canAccess: (user) =>
                Boolean(user?.permissions.documents_manage_terms_of_use_and_privacy
                    || user?.permissions.documents_manage_guardian_app_terms_of_use_and_privacy),
            accessInformation: {
                icon: faFileLines,
                navigate: (navigation) => navigation.navigate('Documents', { screen: 'TermsAndPrivacyGuardianApp' }),
            },
            initialParams: () => ({
                limit: 25,
                page: 1,
            }),
        },
        TermsAndPrivacyCitizenApp: {
            path: 'terms-and-privacy-citizen-app',
            selectedItem: 'terms-and-privacy-citizen-app',
            component: TermsAndPrivacyCitizenApp,
            label: 'TermsAndPrivacyCitizenApp',
            canAccess: (user) =>
                Boolean(user?.permissions.documents_manage_terms_of_use_and_privacy
                    || user?.permissions.documents_manage_citizen_app_terms_of_use_and_privacy),
            accessInformation: {
                icon: faFileLines,
                navigate: (navigation) => navigation.navigate('Documents', { screen: 'TermsAndPrivacyCitizenApp' }),
            },
            initialParams: () => ({
                limit: 25,
                page: 1,
            }),
        },
        TermsAndPrivacyPlatformForm: {
            path: 'terms-and-privacy-platform-app/form/:id?',
            selectedItem: 'terms-and-privacy-platform-app',
            component: TermsAndPrivacyPlatformForm,
            label: 'termsAndPrivacy',
            canAccess: (user) =>
                Boolean(user?.permissions.documents_manage_terms_of_use_and_privacy
                    || user?.permissions.documents_manage_platform_terms_of_use_and_privacy),
            initialParams: () => ({}),
        },
        TermsAndPrivacyGuardianForm: {
            path: 'terms-and-privacy-guardian-app/form/:id?',
            selectedItem: 'terms-and-privacy-guardian-app',
            component: TermsAndPrivacyGuardianForm,
            label: 'termsAndPrivacy',
            canAccess: (user) =>
                Boolean(user?.permissions.documents_manage_terms_of_use_and_privacy
                    || user?.permissions.documents_manage_guardian_app_terms_of_use_and_privacy),
            initialParams: () => ({}),
        },
        TermsAndPrivacyCitizenForm: {
            path: 'terms-and-privacy-citizen-app/form/:id?',
            selectedItem: 'terms-and-privacy-citizen-app',
            component: TermsAndPrivacyCitizenForm,
            label: 'termsAndPrivacy',
            canAccess: (user) =>
                Boolean(user?.permissions.documents_manage_terms_of_use_and_privacy
                    || user?.permissions.documents_manage_citizen_app_terms_of_use_and_privacy),
            initialParams: () => ({}),
        },
    },
};
